export default __webpack_public_path__ + "static/media/cp_geo_vc.1474ccf5.svg";